/**
 * Maps widget payload to LeadCreateInput for makeContact (meta is added separately).
 */
import type { LeadCreateInput } from '../gql/graphql'
import type { ContactMeSubmitPayload } from '../../types'

export function toMakeContactVariables(
  payload: ContactMeSubmitPayload,
  propertyId?: string
): { data: LeadCreateInput } {
  return {
    data: {
      email: payload.email,
      phone: payload.phone || undefined,
      source: payload.source,
      acceptPrivacyPolicy: true,
      acceptMarketing: false,
      personalData: {
        set: {
          firstname: payload.firstName || undefined,
          phone: payload.phone || undefined,
          email: payload.email,
        },
      },
      notes: {
        set: [`Has WhatsApp: ${payload.hasWhatsApp}`],
      },
      ...(propertyId ? { property: { connect: { id: propertyId } } } : {}),
    },
  }
}
